import { RootState } from '../../../../redux/store';

export const selectMessagesBySessionId = (state: RootState) => state.chatMessages.bySessionId;
